function storageKey(userId) {
    return `taskCollapsed:${userId}`;
}

function readMap(userId) {
    if (!userId) return {};
    try {
        const raw = localStorage.getItem(storageKey(userId));
        if (!raw) return {};
        const parsed = JSON.parse(raw);
        if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
            return parsed;
        }
    } catch {
        // Missing or corrupt storage — treat as no saved prefs.
    }
    return {};
}

function writeMap(userId, map) {
    if (!userId) return;
    try {
        localStorage.setItem(storageKey(userId), JSON.stringify(map));
    } catch {
        // Quota or private mode — ignore; collapse still works in-session.
    }
}

// Returns true (collapsed), false (expanded), or null if this user has no saved
// preference for the task. Callers should default null to expanded.
function getTaskCollapsed(userId, taskId) {
    if (!userId || !taskId) return null;
    const value = readMap(userId)[taskId];
    return typeof value === 'boolean' ? value : null;
}

function setTaskCollapsed(userId, taskId, collapsed) {
    if (!userId || !taskId) return;
    const map = readMap(userId);
    map[taskId] = collapsed;
    writeMap(userId, map);
}

export { getTaskCollapsed, setTaskCollapsed };
